export const TEXT_CLASS =
    " text-xs md:text-sm font-medium font-Montserrat not-italic	text-Error_Default  ";
export const CONTAINER_CLASS = "flex flex-row justify-start items-center";
